import { ref } from 'vue';

/**
 * The schedule/trainee/matrix-revision fields every training creation form
 * shares, regardless of how many ministrantes or documents it manages.
 */
export function useTrainingFormFields() {
  return {
    title: ref(''),
    notes: ref(''),
    scheduledByMemberId: ref<number | null>(null),
    scheduledByPositionId: ref<number | null>(null),
    scheduledDate: ref<Date | null>(null),
    traineeMemberId: ref<number | null>(null),
    traineePositionId: ref<number | null>(null),
    trainingMatrixRevisionId: ref<number | null>(null),
  };
}
